import React, { useState, useEffect } from 'react';
import Navbar from '../Components/Common/Navbar';
import Footer from '../Components/Footer/Footer';
import { Box, Typography, Grid, useMediaQuery, useTheme } from '@mui/material';
import { getAllFeaturedRestaurants } from '../../api';
import RestaurantCard from '../Components/Common/RestaurantCard';
import { Link } from 'react-router-dom';

const FeaturedMain = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState(null);

  const handleGetFeatured = async () => {
    setIsLoading(true);
    await getAllFeaturedRestaurants()
      .then((res) => {
        setIsLoading(false);
        if (res?.data?.status) {
          setData(res?.data?.result);
        }
      })
      .catch((err) => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    handleGetFeatured();
  }, []);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  return (
    <>
      <Navbar />
      <Box
        sx={{
          pt: 10,
          width: { xl: '75%', lg: '85%', sm: '90%', xs: '90%' },
          margin: '0 auto',
          pb: 6,
        }}
      >
        <Box sx={{ mt: 4 }}>
          <Typography variant="h2" sx={{ fontSize: '20px', fontWeight: 700 }}>
            {' '}
            Featured restaurants
          </Typography>
          <Typography sx={{ mt: 1, color: '#2f3441' }}>
            Discover the best restaurants in your local area
          </Typography>
        </Box>

        <Box sx={{ mt: 3 }}>
          {isLoading ? (
            <Grid container spacing={isMobile ? 1 : 3}>
              {[1, 2, 3, 4, 5, 6, 7, 8]?.map((restaurant, index) => (
                <Grid item lg={3} md={3} sm={4} xs={6} key={index}>
                  <RestaurantCard loading />
                </Grid>
              ))}
            </Grid>
          ) : (
            <Grid container spacing={isMobile ? 1 : 3}>
              {data?.map((restaurant, index) => (
                <Grid item lg={3} md={3} sm={4} xs={6} key={index}>
                  <Link to={`/restaurant/${restaurant?.RestaurantName}`}>
                    <RestaurantCard restaurant={restaurant} />
                  </Link>
                </Grid>
              ))}
            </Grid>
          )}
        </Box>
      </Box>
      <Footer />
    </>
  );
};

export default FeaturedMain;
